<script lang="ts">
  import { SUBMIT_CHORD_LABEL } from './keyboard';

  const GROUPS: { title: string; rows: { keys: string[]; label: string }[] }[] = [
    {
      title: 'ホーム',
      rows: [
        { keys: ['L'], label: 'ラボ' },
        { keys: ['M'], label: '計算量メーター' },
        { keys: [','], label: '設定' },
      ],
    },
    {
      title: '問題',
      rows: [
        { keys: [SUBMIT_CHORD_LABEL], label: 'ジャッジ（エディタの中）' },
        { keys: ['Esc', 'Tab'], label: 'エディタから出る' },
      ],
    },
    {
      title: 'ドリル',
      rows: [
        { keys: ['Enter'], label: '採点する（1 行入力・選択肢）' },
        { keys: [SUBMIT_CHORD_LABEL], label: '採点する（複数行の入力）・ジャッジ（エディタ）' },
        { keys: ['Enter', '→'], label: '採点後に次のカードへ' },
        { keys: ['1', '…', '6'], label: '選択肢を選ぶ' },
        { keys: ['?'], label: '次のヒントを開く' },
        { keys: ['←'], label: '前のカードを見る' },
        { keys: ['Esc'], label: '入力欄から出る / ヒントを閉じる / 中断' },
      ],
    },
    {
      title: 'ラボ',
      rows: [
        { keys: ['1', '2', '3'], label: '段階の切り替え' },
        { keys: ['P'], label: 'スタックに積む（append）' },
        { keys: ['O'], label: 'スタックから取る（popLast）' },
        { keys: ['E'], label: 'キューに並ぶ（append）' },
        { keys: ['D'], label: 'キューの先頭を出す（removeFirst）' },
      ],
    },
    {
      title: 'エディタ',
      rows: [
        { keys: ['Tab'], label: 'インデント' },
        { keys: ['Esc', 'Tab'], label: 'エディタから出る' },
      ],
    },
  ];
</script>

<p class="note">入力欄にフォーカスがあるときは、文字キーと矢印キーは入力として扱います。</p>
{#each GROUPS as g (g.title)}
  <table class="keys">
    <caption>{g.title}</caption>
    <thead class="visually-hidden">
      <tr><th scope="col">キー</th><th scope="col">動作</th></tr>
    </thead>
    <tbody>
      {#each g.rows as r (r.label)}
        <tr>
          <th scope="row">
            {#each r.keys as k (k)}<kbd>{k}</kbd>{/each}
          </th>
          <td>{r.label}</td>
        </tr>
      {/each}
    </tbody>
  </table>
{/each}

<style>
  .note {
    font-size: var(--fs-sm);
    color: var(--text-soft);
    margin-bottom: var(--space-3);
  }
  .keys {
    width: 100%;
    margin-bottom: var(--space-4);
    font-size: var(--fs-sm);
  }
  caption {
    text-align: left;
    font-weight: var(--fw-semibold);
    padding-bottom: var(--space-1);
  }
  th,
  td {
    padding: var(--space-1) var(--space-2);
    border-bottom: 1px solid var(--border);
    text-align: left;
    vertical-align: top;
  }
  th {
    width: 1%;
    padding-right: var(--space-4);
    white-space: nowrap;
    font-weight: var(--fw-regular);
  }
  kbd + kbd {
    margin-left: var(--space-1);
  }
</style>
